import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-jobs-first-look-page')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/first-look-page"
    infiniteScroll={true}
    firstLookPage="true"
    message_if_none = 'No jobs in progress yet.'
  />,
  document.getElementById('react-component-g4-logistics-portal-jobs-first-look-page'));
}
